import React, { useState, useMemo } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Breadcrumb from '../components/Breadcrumb';
import Filters from '../components/Filters';
import ProductGrid from '../components/ProductGrid';
import Footer from '../components/Footer';
import { products } from '../data/mockData';
import { Filter, X } from 'lucide-react';

const EngagementRingsPage = () => {
  const [selectedFilters, setSelectedFilters] = useState({
    look: null,
    metal: null,
    shape: null,
  });
  const [sortBy, setSortBy] = useState('featured');
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);

  const handleFilterChange = (type, value) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [type]: prev[type] === value ? null : value,
    }));
  };

  const filteredProducts = useMemo(() => {
    let result = [...products];

    if (selectedFilters.look) {
      result = result.filter((p) => p.category === selectedFilters.look);
    }
    if (selectedFilters.metal) {
      result = result.filter((p) => p.metal === selectedFilters.metal);
    }
    if (selectedFilters.shape) {
      result = result.filter((p) => p.shape === selectedFilters.shape);
    }

    // Sort
    switch (sortBy) {
      case 'price-low':
        result.sort((a, b) => a.price - b.price);
        break;
      case 'price-high':
        result.sort((a, b) => b.price - a.price);
        break;
      case 'a-z':
        result.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case 'z-a':
        result.sort((a, b) => b.name.localeCompare(a.name));
        break;
      default:
        break;
    }

    return result;
  }, [selectedFilters, sortBy]);

  const activeFiltersCount = Object.values(selectedFilters).filter(Boolean).length;

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Breadcrumb />

      {/* Mobile Filter Button */}
      <div className="lg:hidden px-4 pb-4">
        <button
          onClick={() => setMobileFiltersOpen(true)}
          className="flex items-center gap-2 text-sm text-[#1a365d] border border-[#1a365d] px-4 py-2"
        >
          <Filter className="w-4 h-4" />
          Filters
          {activeFiltersCount > 0 && (
            <span className="bg-[#1a365d] text-white w-5 h-5 rounded-full text-xs flex items-center justify-center">
              {activeFiltersCount}
            </span>
          )}
        </button>
      </div>

      {/* Mobile Filters Drawer */}
      {mobileFiltersOpen && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div
            className="absolute inset-0 bg-black/50"
            onClick={() => setMobileFiltersOpen(false)}
          />
          <div className="absolute left-0 top-0 bottom-0 w-80 max-w-full bg-white overflow-y-auto">
            <div className="flex items-center justify-between p-4 border-b border-gray-200">
              <h2 className="text-lg font-medium text-[#1a365d]">Filters</h2>
              <button onClick={() => setMobileFiltersOpen(false)}>
                <X className="w-5 h-5 text-gray-500" />
              </button>
            </div>
            <div className="p-4">
              <Filters
                selectedFilters={selectedFilters}
                onFilterChange={handleFilterChange}
              />
            </div>
          </div>
        </div>
      )}

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-16 pb-16">
        <div className="flex gap-8">
          {/* Desktop Filters */}
          <div className="hidden lg:block">
            <Filters
              selectedFilters={selectedFilters}
              onFilterChange={handleFilterChange}
            />
          </div>

          {/* Product Grid */}
          <ProductGrid
            products={filteredProducts}
            sortBy={sortBy}
            onSortChange={setSortBy}
          />
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default EngagementRingsPage;
